import { Component, OnInit, ViewChild, Input, ElementRef } from "@angular/core";
import "anychart";
import { Interval } from "../achart/achart.annotation.tools";

@Component({
    selector: "app-scaleBar",
    // templateUrl: "./scaleBar.component.html"
    template: `
        <div
            class="scalebarContainer d-inline-block p-2"
            [ngStyle]="{ width: widthValue, height: heightValue }"
            #scaleContainer
        ></div>
    `
    // styles: [require('./scaleBar.component.scss')]
})
export class ScaleBarComponent implements OnInit {
    @ViewChild("scaleContainer") container: any = null;
    @Input() value: string = "";
    @Input() type: string = "horizontal";
    @Input() minimum: number = 0;
    @Input() maximum: number = 100;
    @Input() gradientType: string = "default";

    @Input() markerColor: string = "#000000";

    private _scaleValue: string = "";

    private gauage: anychart.charts.LinearGauge;
    private _colorscale: any;
    public scaleBar: anychart.core.linearGauge.ScaleBar;
    public scaleBarMarker: anychart.core.linearGauge.pointers.Marker;
    public scale: anychart.scales.ScatterBase;
    public axis: anychart.core.axes.LinearGauge;

    // public gauage:any;

    constructor() {
        this.gauage = anychart.gauges.linear();
        this.scaleBarMarker = this.gauage.marker(0);
        this.scaleBar = this.gauage.scaleBar(0);
        this.scale = this.gauage.scale();
        this.axis = this.gauage.axis();
    }

    set scaleBarValue(v: string) {
        this._scaleValue = v;
        this.gauage.contextMenu().enabled(false);

        if (this.scaleBarValue != "NaN") {
            //  console.log(this.scaleBarValue);
            this.gauage.data(this.scaleBarValue);
        }
    }

    get scaleBarValue(): string {
        return this._scaleValue;
    }

    defaultColorScale() {
        if (this.gradientType == "BS") {
            this.ColorScale = anychart.scales.ordinalColor().ranges([
                {
                    from: -100,
                    to: 100,
                    color: [
                        "#238a15",
                        "#61a41c",
                        "#a0cd28",
                        "#dee931",
                        "#feeb34",
                        "#dee931",
                        "#fdb32b",
                        "#fc1c1c",
                        "#fc0d1b"
                    ]
                }
            ]);
        }

        if (this.gradientType == "volatility") {
            this.ColorScale = anychart.scales.ordinalColor().ranges([
                {
                    from: 0,
                    to: 150,
                    color: [
                        "#fc0d1b",
                        "#fc1c1c",
                        "#fdb32b",
                        "#dee931",
                        "#61a41c",
                        "#238a15",
                        "#61a41c",
                        "#dee931",
                        "#fdb32b",
                        "#fc1c1c",
                        "#fc0d1b"
                    ]
                }
            ]);
        }
    }

    defaultLayout() {
        switch (this.type) {
            case "vertical":
                var orientation: any = {
                    layout: "vertical",
                    axisOrientation: "left",
                    markerType: "triangle-left",

                    width: "100%",
                    gaugeWidth: "100%",
                    height: "100%",
                    marginLeft: "40%",
                    marginTop: "0%",
                    marginRight: "7%",
                    markerScale: "20px",
                    paddingTop: "0px",

                    containerWidth: "130px",
                    containerHeight: "100%",
                    inverted: false,
                    colorScale: anychart.scales.linearColor([
                        "#fc0e1b",
                        "#fc211c",
                        "#fc241c",
                        "#fc5e20",
                        "#fee132",
                        "#defd35",
                        "#3ac021",
                        "#3ac021",
                        "#3ac021",
                        "#138413"
                    ])
                };
                break;

            case "horizontal":
                var orientation: any = {
                    layout: "horizontal",
                    axisOrientation: "top",
                    markerType: "triangle-up",
                    width: "-100%",
                    gaugeWidth: "100%",
                    height: "120%",
                    marginLeft: "0",
                    marginTop: "-20px",
                    marginRight: "0",
                    markerScale: "20px",
                    paddingTop: "30px",

                    containerWidth: "100%",
                    containerHeight: "100px",
                    inverted: true,
                    colorScale: this.ColorScale
                };
                break;
        }
        this.widthValue = orientation.containerWidth;
        this.heightValue = orientation.containerHeight;
        if (this.gradientType == "BS") {
            this.scale.inverted(orientation.inverted);
        }

        this.gauage.background().fill("#000000", 0);
        this.gauage.background().stroke("0");
        this.gauage.layout(orientation.layout);
        this.gauage.height(orientation.height);
        this.gauage.width(orientation.gaugeWidth);

        this.scaleBar.colorScale(orientation.colorScale);

        this.scaleBarMarker.offset("5px");
        this.scaleBarMarker.width(orientation.markerScale);

        this.scaleBarMarker.fill(this.markerColor);

        this.scaleBarMarker.stroke("#000000");

        this.scaleBarMarker.zIndex(10);
        this.scaleBarMarker.type(orientation.markerType);

        this.scale.minimum(this.minimum);
        this.scale.maximum(this.maximum);

        this.axis.minorTicks(true);
        this.axis.minorTicks().stroke("#ffffff");

        this.axis.width("1%");
        this.axis.offset("-1%");
        this.axis.orientation(orientation.axisOrientation);
        this.axis.labels().format("{%value}");

        this.axis.labels().fontColor("#ffffff");

        var padding = this.gauage.padding();
        padding.left("10px");
        padding.right("10px");
        padding.top("10px");
        padding.bottom("10px");
        var margin = this.gauage.margin();
        margin.top(orientation.marginTop);
    }

    set ColorScale(v: any) {
        this._colorscale = v;
    }

    get ColorScale(): any {
        return this._colorscale;
    }

    private _widthValue: string = "100px";
    public get widthValue(): string {
        return this._widthValue;
    }
    public set widthValue(value: string) {
        this._widthValue = value;
    }

    private _heightValue: string = "100px";
    public get heightValue(): string {
        return this._heightValue;
    }
    public set heightValue(value: string) {
        this._heightValue = value;
    }

    createScaleBar() {
        setTimeout(() => {
            this.defaultColorScale();
            this.defaultLayout();

            this.gauage.container(this.container.nativeElement);
            this.gauage.draw();
        }, 1);
    }

    ngOnInit(): void {
        this.scaleBarValue = this.value;
        this.createScaleBar();
    }
}
